import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { TextbookPageRoutingModule } from './textbook-routing.module';

import { TextbookPage } from './textbook.page';
import {ComponentsModule} from "../../shared/components/components.module";
import {RoundProgressComponent} from "angular-svg-round-progressbar";
import {SharedModule} from "../../shared/shared.module";

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        IonicModule,
        TextbookPageRoutingModule,
        ComponentsModule,
        RoundProgressComponent,
        SharedModule
    ],
  declarations: [TextbookPage]
})
export class TextbookPageModule {}
